export default __webpack_public_path__ + "static/img3-e26a967dc13cbc3ae81f0befe69cbac4.png";